import React from "react";
import PropTypes from "prop-types";

const CARD_COLORS = ["#003366", "#fc8716", "#fccb02", "#8dbe46"];
const CONFIGURED_OBJECTS_LABEL = "Objects configured";
const FONT_SIZE = "12px";
const ACCENT_COLOR = "#9ca3af";
const ZERO_INDEX = 0;

const StatusCard = ({
  index,
  title,
  count,
  totalObjects,
  cardStatus,
  status,
  handleCardClick,
}) => {
  const percent =
    totalObjects > 0 ? Math.round((count / totalObjects) * 100) : 0;

  const isActive = cardStatus === status;
  const cardClassName = isActive ? "kpi-card-active" : "kpi-card";
  const percentageLabel =
    index === ZERO_INDEX ? CONFIGURED_OBJECTS_LABEL : `${percent}% of total`;

  const handleClick = React.useCallback(() => {
    handleCardClick(cardStatus);
  }, [cardStatus, handleCardClick]);

  const handleKeyDown = React.useCallback(
    (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleCardClick(cardStatus);
      }
    },
    [cardStatus, handleCardClick]
  );

  return (
    <div
      className={cardClassName}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="button"
      tabIndex={0}
      aria-pressed={isActive}
    >
      <h2 className="kpi-title">{title}</h2>
      <p
        className="text-2xl font-bold mt-2"
        style={{ color: CARD_COLORS[index] }}
      >
        {count}
      </p>
      <span
        className="kpi-percentage"
        style={{ fontSize: FONT_SIZE, color: ACCENT_COLOR }}
      >
        {percentageLabel}
      </span>
    </div>
  );
};

StatusCard.propTypes = {
  index: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  totalObjects: PropTypes.number.isRequired,
  cardStatus: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  handleCardClick: PropTypes.func.isRequired,
};

export default StatusCard;